<script lang="ts">
    import {Alert, Button, Modal, Spinner} from "flowbite-svelte";
    import {CheckCircleOutline, HourglassOutline} from "flowbite-svelte-icons";
    import {formDataPost, get} from "$lib/api";
    import {onMount} from "svelte";
    import wordDocumentParser from "$lib/utils/templating/wordDocumentParser";
    import {PUBLIC_API_PATH} from "$env/static/public";
    import {contractVariables, matchContractVariables} from "$lib/utils/templating/contractVariables";
    import {getUnits} from "$lib/calls/unit";
    import {storeEmployeeImage} from "$lib/calls/files";
    import type {Contract, ContractHistory, Employee} from "$lib/types/employee";
    import {tariffs} from "$lib/stores/tariffs";

    export let contract: Contract;
    export let employee: Employee;

    let currentHistory: ContractHistory;

    let processing = false

    let previewBlob: Blob;

    const processQueue = async (blob: Blob) => {
        processing = true
        try{
            contract = await formDataPost('/document/contract', {
                file: blob,
                connectedEntity: 'EmployeeContract',
                entityId: contract.id,
                historyId: currentHistory.id
            })
            // TODO: update currentHistory!
            location.reload();
        } catch (e) {
            alert('Fehler aufgetreten: ' + e.message)
        }

        processing = false
    }
    onMount(async () => {
        if($tariffs.length === 0){
            $tariffs = await get('/tariffs')
        }
        currentHistory = contract.history.reduce((max, current) => {
            return current.endDate.stamp > max.endDate.stamp ? current : max
        });

    })


</script>

<div>
    {#if currentHistory && currentHistory.employmentContractStatus !== 'synchronized'}

        <Alert color="dark">
            <div class="flex gap-5 mb-5 items-center">
                <CheckCircleOutline color="green"/>
                <div class="flex-1">Vertrag angelegt</div>
            </div>
            <div class="flex gap-5 mb-5 items-center">
                <CheckCircleOutline color="green"/>
                <div class="flex-1">Vertragsunterlagen erstellt</div>
            </div>
            <div class="flex gap-5 mb-5 items-center">
                {#if currentHistory.employmentContractStatus === 'waiting_for_employee_signature' || currentHistory.employmentContractStatus === 'planned' || currentHistory.employmentContractStatus === 'waiting_for_hr_signature'}
                    <HourglassOutline />
                    {#if currentHistory.employmentContractStatus === 'planned'}
                        <div class="flex-1 text-red-600">System verarbeitet noch.</div>
                    {:else if currentHistory.employmentContractStatus === 'waiting_for_employee_signature'}
                        <div class="flex-1">Mitarbeiter hat noch nicht unterschrieben.</div>
                    {:else}
                        <div class="flex-1">Mitarbeiter hat unterschrieben, Gegenzeichnung fehlt.</div>
                    {/if}

                {:else}
                    <CheckCircleOutline color="green"/>
                    <div class="flex-1">Vertrag signiert</div>
                {/if}
            </div>
            <div class="flex gap-5 mb-5 items-center">
                <HourglassOutline class="text-primary-600"/>
                <div class="flex-1 text-primary-600">Synchronisation ausstehend</div>
            </div>
        </Alert>

    {/if}
</div>